import { CalendarDateTime, getLocalTimeZone } from '@internationalized/date';
import { type Formatters } from 'react-day-picker';

export function toDateFieldValue(date?: Date): CalendarDateTime | null {
    if (!date || Number.isNaN(date.getTime())) return null;
    return new CalendarDateTime(
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
    );
}

export function fromDateFieldValue(
    value: CalendarDateTime | null,
): Date | undefined {
    if (!value) return undefined;
    return value.toDate(getLocalTimeZone());
}

// React Aria only applies minValue/maxValue to arrow stepping. A typed value
// outside the range is reported as-is, so it is clamped before it reaches the
// consumer. The field is controlled, so the display follows immediately.
export function clampToRange(
    date: Date | undefined,
    minValue: Date | undefined,
    maxValue: Date | undefined,
): Date | undefined {
    if (!date) return date;
    if (minValue && date < minValue) return minValue;
    if (maxValue && date > maxValue) return maxValue;
    return date;
}

export function createNarrowWeekdayFormatter(
    language: string,
): Formatters['formatWeekdayName'] {
    const formatter = new Intl.DateTimeFormat(language, { weekday: 'narrow' });
    return (date) => formatter.format(date);
}
